// Toasts — неблокирующие уведомления вместо нативных alert() (правило проекта
// feedback_no_native_dialogs). Стек справа снизу, авто-скрытие, клик закрывает.

import React from 'react';
import useCadStore from '../store/useCadStore';

// Хелпер для вызова из любого места (в т.ч. вне React-компонентов).
export function toast(text, type = 'info') {
    useCadStore.getState().pushToast(text, type);
}

const COLORS = {
    info:    { bg: '#2b3038', bar: '#4a90d0' },
    error:   { bg: '#3a2526', bar: '#cc3344' },
    success: { bg: '#243a2a', bar: '#2aa84a' },
};

export default function Toasts() {
    const toasts = useCadStore((s) => s.toasts);
    const dismiss = useCadStore((s) => s.dismissToast);
    if (!toasts.length) return null;
    return (
        <div style={{
            position: 'fixed', right: 16, bottom: 16, zIndex: 4000,
            display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 380,
        }}>
            {toasts.map((t) => {
                const c = COLORS[t.type] || COLORS.info;
                return (
                    <div key={t.id}
                        onClick={() => dismiss(t.id)}
                        style={{
                            display: 'flex', alignItems: 'stretch', cursor: 'pointer',
                            background: c.bg, color: '#e8ecf1', borderRadius: 6,
                            boxShadow: '0 4px 16px rgba(0,0,0,0.4)', overflow: 'hidden',
                            font: '13px/1.35 system-ui, sans-serif',
                        }}>
                        <div style={{ width: 4, background: c.bar, flex: '0 0 auto' }}/>
                        <div style={{ padding: '9px 12px' }}>{t.text}</div>
                        {/* Счётчик повторов: одинаковые сообщения не плодятся
                            отдельными плашками, а копятся здесь. */}
                        {t.count > 1 && (
                            <div style={{
                                alignSelf: 'center', margin: '0 10px 0 2px',
                                padding: '1px 7px', borderRadius: 9,
                                background: 'rgba(255,255,255,0.14)',
                                font: '600 12px/1.5 system-ui, sans-serif',
                                flex: '0 0 auto',
                            }}>
                                ×{t.count}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
